import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Anexa o token Bearer automaticamente em toda chamada para a API
const originalFetch = window.fetch;
window.fetch = (input, init = {}) => {
  const url = typeof input === 'string' ? input : input.url;
  if (url && url.includes('api.faeworks.com.br')) {
    const sessao = JSON.parse(localStorage.getItem('clienteSession') || 'null');
    if (sessao && sessao.token) {
      init = { ...init, headers: { ...(init.headers || {}), Authorization: `Bearer ${sessao.token}` } };
    }
  }
  return originalFetch(input, init);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
